import Vue from 'vue';
import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    //returns installed service workers
    if (registrations.length) {
      for (let registration of registrations) {
        registration.unregister();
        console.log("rm service worker");
      }
    }
  });
}